import { useMemo } from 'react';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';
import { PAGES } from 'constants/pages';
import { useGetTicketsQuery } from 'data/__generated__';

import { getTicketsColumns, type TicketRow, type TicketsFilter } from '../constants/ticketsColumns';

export const TicketsList = () => {
    const { data, loading, error } = useGetTicketsQuery();

    const tickets = data?.tickets ?? [];
    const columns = useMemo(() => getTicketsColumns(tickets), [tickets]);

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (error || !data) {
        throw new Error('Une erreur est survenue lors de la récupération des tickets');
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden" data-test="tickets-list">
            <DataTable<TicketRow, TicketsFilter>
                columns={columns}
                data={tickets}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => PAGES.ticketDetails.url.replace(':ticketId', row._id)}
                defaultSortBy="odooCreateDate"
                defaultSortOrder="desc"
                searchPlaceholder="Référence, intitulé, site…"
                emptyMessage="Aucun ticket."
            />
        </div>
    );
};
